import { useEffect, useMemo } from 'react'
import { useLocalStorage } from 'react-use'

import { LocalStorageKeys } from '../../../../../enums/localStorageKeys'
import { useHasUnsettledCorrection } from './useHasUnsettledCorrection'

export const useCorrectionTabVisitTracker = (correctionId?: string, isActive?: boolean) => {
  const { hasUnsettledCorrection } = useHasUnsettledCorrection(correctionId || '')

  const localStorageKey = useMemo(() => {
    return `${LocalStorageKeys.VatDeclarationsCorrectionsTabsBadge}-${correctionId}`
  }, [correctionId])

  const [visitedCorrectionId, setVisitedCorrectionId] = useLocalStorage(localStorageKey, '')

  const shouldShowBadge = useMemo(() => {
    return !!correctionId && hasUnsettledCorrection && visitedCorrectionId !== correctionId
  }, [correctionId, visitedCorrectionId, hasUnsettledCorrection])

  useEffect(() => {
    if (correctionId && isActive && hasUnsettledCorrection) {
      setVisitedCorrectionId(correctionId)
    }
  }, [correctionId, isActive, hasUnsettledCorrection, setVisitedCorrectionId])

  return { shouldShowBadge }
}
